module.exports = __webpack_public_path__ + "img/fruit-persimmons-350x184.151db2b0.jpg";